'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'bullseye-arrow';
var width = 576;
var height = 512;
var aliases = [127919];
var unicode = 'f648';
var svgPathData = ['M64 256c0-123.7 100.3-224 224-224 13.8 0 27.3 1.3 40.5 3.6-1.3 1.3-2.6 2.6-3.9 3.9 2.3 13.8 5.8 35 10.6 63.5-14.9-4.6-30.8-7.1-47.2-7.1-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160c0-16.4-2.5-32.3-7.1-47.2 28.6 4.8 49.8 8.3 63.5 10.6 1.3-1.3 2.6-2.6 3.9-3.9 2.4 13.1 3.6 26.7 3.6 40.5 0 123.7-100.3 224-224 224S64 379.7 64 256z', 'M496 48c34.3 13.7 61 24.4 80 32-10 10-39.3 39.3-88 88L411.4 155.2 291.3 275.3 268.7 252.7 388.8 132.6 376 56c48.7-48.7 78.1-78.1 88-88 7.6 19 18.3 45.7 32 80zm-19 85.7l42-42-31.5-12.6-48.3 48.3 37.8 6.3zm-60.4-28.9l48.3-48.3-12.6-31.5-42 42 6.3 37.8zM288 0c23.3 0 45.8 3.1 67.2 8.9-8.7 8.7-17.6 17.6-26.7 26.7-13.1-2.4-26.7-3.6-40.5-3.6-123.7 0-224 100.3-224 224S164.3 480 288 480 512 379.7 512 256c0-13.8-1.3-27.3-3.6-40.5 9.1-9.1 18-18 26.7-26.7 5.8 21.4 8.9 43.9 8.9 67.2 0 141.4-114.6 256-256 256S32 397.4 32 256 146.6 0 288 0zm0 96c16.4 0 32.3 2.5 47.2 7.1l2.2 13.1-16.2 16.2c-10.6-2.8-21.7-4.3-33.2-4.3-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128c0-11.5-1.5-22.6-4.3-33.2l16.2-16.2 13.1 2.2c4.6 14.9 7.1 30.8 7.1 47.2 0 88.4-71.6 160-160 160S128 344.4 128 256 199.6 96 288 96z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBullseyeArrow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;